import * as React from 'react';

type Params = {
  isEnabled: boolean;
  onIntersect: () => void;
  rootMargin?: string;
};

const useLoadMoreObserver = ({
  isEnabled,
  onIntersect,
  rootMargin = '200px',
}: Params): React.RefObject<HTMLDivElement> => {
  const triggerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const target = triggerRef.current;
    if (!target || !isEnabled) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          onIntersect();
        }
      },
      { rootMargin }
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [isEnabled, onIntersect, rootMargin]);

  return triggerRef;
};

export default useLoadMoreObserver;
